module.exports = __webpack_public_path__ + "static/img/2_8@2x.a310bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_8@2x.png
// module id = +d9o
// module chunks = 8